import React, {Component} from 'react';
import {message} from 'antd';
import {connect} from "react-redux";
import {liveModeLoadingMessages, previewCameraType} from '../../utils/const';
import {getLiveImageMoveAndFocus, updateImageFetching} from '../../redux_actions/livemode.action';

class KeyboardMovementListener extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        document.addEventListener('keyup', this.keyboardEventAction);
    }

    componentWillUnmount = () => {
        document.removeEventListener('keyup', this.keyboardEventAction);
    }

    keyboardEventAction = (e) => {
        if (!this.props.livemode.inputFieldInFocus && this.props.livemode.accessToLiveMode && !this.props.livemode.useLiveModeInViewMode) {
            if (this.props.adminState.slotID >= 0) {

                if (!this.props.adminState.doDropDistanceAF && (this.props.liveView.url != undefined && this.props.livemode.atLeastOneImageFetched)) {
                    // Preview is rotated 90 degrees, so x and y is swapped
                    if (e.code === 'ArrowRight') {
                        if (this.props.adminState.previewCamera !== previewCameraType.PREVIEW_CAMERA_NO_OBJ) {
                            if (this.props.adminState.numberOfSlots > 1) {
                                this.moveAndFocus(null, (this.props.livemode.movementStepSize * -1000), null);
                                // this.moveAndFocus(null, (this.props.livemode.movementStepSize * -1000), null);
                            } else {
                                this.moveAndFocus(null, (this.props.livemode.movementStepSize * -1000), null);
                            }
                        } else {
                            this.moveAndFocus(null, (this.props.livemode.movementStepSize * 1000), null);
                        }
                    } else if (e.code === 'ArrowDown') {
                        if (this.props.adminState.previewCamera !== previewCameraType.PREVIEW_CAMERA_NO_OBJ) {
                            if (this.props.adminState.numberOfSlots > 1) {
                                this.moveAndFocus((this.props.livemode.movementStepSize * -1000), null, null);
                                // this.moveAndFocus((this.props.livemode.movementStepSize * -1000), null, null);
                            } else {
                                this.moveAndFocus((this.props.livemode.movementStepSize * -1000), null, null);
                            }
                        } else {
                            this.moveAndFocus((this.props.livemode.movementStepSize * -1000), null, null);
                        }
                    } else if (e.code === 'ArrowLeft') {
                        if (this.props.adminState.previewCamera !== previewCameraType.PREVIEW_CAMERA_NO_OBJ) {
                            if (this.props.adminState.numberOfSlots > 1) {
                                this.moveAndFocus(null, (this.props.livemode.movementStepSize * 1000), null);
                                // this.moveAndFocus(null, (this.props.livemode.movementStepSize * 1000), null);
                            } else {
                                this.moveAndFocus(null, (this.props.livemode.movementStepSize * 1000), null);
                            }
                        } else {
                            this.moveAndFocus(null, (this.props.livemode.movementStepSize * -1000), null);
                        }
                    } else if (e.code === 'ArrowUp') {
                        if (this.props.adminState.previewCamera !== previewCameraType.PREVIEW_CAMERA_NO_OBJ) {
                            if (this.props.adminState.numberOfSlots > 1) {
                                this.moveAndFocus((this.props.livemode.movementStepSize * 1000), null, null);
                                // this.moveAndFocus((this.props.livemode.movementStepSize *1000), null, null);
                            } else {
                                this.moveAndFocus((this.props.livemode.movementStepSize * 1000), null, null);
                            }
                        } else {
                            this.moveAndFocus((this.props.livemode.movementStepSize * 1000), null, null);
                        }
                    }
                } else {
                    if (e.code === 'ArrowUp' || e.code === 'ArrowLeft' || e.code === 'ArrowDown' || e.code === 'ArrowRight') {
                        message.error("Please go to some position by clicking on the preview image first.", 2.5);
                    }
                }
            } else {
                if (e.code === 'ArrowUp' || e.code === 'ArrowLeft' || e.code === 'ArrowDown' || e.code === 'ArrowRight') {
                    message.error("Please take the preview first.", 2.5);
                }
            }
        }
    }

    moveAndFocus = (x, y, z) => {
        this.props.dispatch(updateImageFetching(true));


        let partsOfUrl = "api~stage~move_and_focus/";
        let url = `/server/scano_text/` + this.props.livemode.deviceId + `/` + partsOfUrl;

        if (this.props.adminState.slotID !== -1) {
            url += '?slotID=' + parseInt(this.props.adminState.slotID);
        } else {
            url += '?slotID=';
        }

        if (x != null) {
            url += '&x=' + parseFloat(x);
        } else {
            url += '&x=';
        }

        if (y != null) {
            url += '&y=' + parseFloat(y);
        } else {
            url += '&y=';
        }

        if (z != null) {
            url += '&z=' + parseFloat(z);
        } else {
            url += '&z=';
        }

        // this.props.adminState.doAutoFocus
        url += "&doAF=" + this.props.adminState.doAutoFocus + "&numZStack=" + parseInt(this.props.livemode.zStackLevels * 2) +
            "&zStackStep=" + parseFloat(this.props.livemode.stepSizeZStack) +
            "&timestamp=" + Date.now();
        this.props.dispatch(getLiveImageMoveAndFocus(url, liveModeLoadingMessages.LOADING_IMAGE, this.props.adminState.slotID,
            this.props.adminState.takeZStack, true, this.props.adminState.areaVisited,
            this.props.adminState.liveModePreviewVectorLayer));
    }

    render() {

        return (
            <div></div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        liveView: state.liveViewReducer,
        adminState: state.adminUrlReducer,
        livemode: state.livemodeReducer,
    };
};

export default connect(mapStateToProps)(KeyboardMovementListener);
